import { render, staticRenderFns } from "./BorderColorIcon.vue?vue&type=template&id=0992e274"
import script from "./BorderColorIcon.vue?vue&type=script&lang=js"
export * from "./BorderColorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports